/**
 * Preset widgets used to wrap dedicated dashboards. Those pages are retired;
 * leftover preset_* configs render an unsupported message.
 */

export const SUPPORTED_PRESETS = [];

export const SUPPORTED_PRESET_TYPES = new Set();

export function isPresetWidgetType(type) {
  return typeof type === 'string' && type.startsWith('preset_');
}

export function isSupportedPreset() {
  return false;
}

export function getPresetLazyComponent() {
  return null;
}

export function getPresetProps() {
  return null;
}
